import React from "react"

/**
 * Bilder in Markdown-Feldern (z. B. „Infos zum Kurs“): Größe und Ausrichtung stehen als
 * Stichworte im Bildtitel, `![Prüfsiegel](https://… "klein rechts")`. Gesetzt werden sie im
 * Admin-Editor (ko-X-main, `views/TextAreaInputMarkdown/markdownImage.ts`) — Stichworte nur
 * gemeinsam ändern. Unbekannte Wörter werden ignoriert, der Titel nicht als Tooltip gezeigt.
 */
const IMAGE_SIZES: { [word: string]: string } = { klein: "120px", mittel: "240px", groß: "480px", voll: "100%" }

export const imageLayoutStyle = (title?: string): React.CSSProperties => {
    const words = (title || "").split(/\s+/)
    const size = words.find((word) => Object.prototype.hasOwnProperty.call(IMAGE_SIZES, word))
    const style: React.CSSProperties = size ? { width: IMAGE_SIZES[size] } : {}

    // Umflossene Bilder samt seitlichem Abstand nie breiter als der Block (Handy, schmales iFrame).
    if (words.includes("links")) {
        return { ...style, float: "left", margin: "0.25em 1em 0.5em 0", maxWidth: "calc(100% - 1em)" }
    }
    if (words.includes("rechts")) {
        return { ...style, float: "right", margin: "0.25em 0 0.5em 1em", maxWidth: "calc(100% - 1em)" }
    }

    return style
}

/** Für ReactMarkdown `components={{ img: MarkdownImage }}`. */
const MarkdownImage = ({ src, alt, title }: { src?: string; alt?: string; title?: string }) => (
    <img src={src} alt={alt} style={imageLayoutStyle(title)} />
)

export default MarkdownImage
